import { DashboardTranslationType } from "../../features/dashboard.types";

export const dashboard: DashboardTranslationType = {
  dashboard: {
    newStory: "Nouvelle Histoire",
    ongoingStories: "Histoires en Cours",
    completedStories: "Histoires Terminées",
    publicStories: "Histoires Publiques",
    loadingStory: "Chargement de l'Histoire",
    pleaseWait: "Veuillez patienter pendant le chargement de votre histoire",
    newCharacter: "Nouveau Personnage",
    characterCard: {
      personality: "Personnalité",
      strengths: "Forces",
      weaknesses: "Faiblesses",
      skills: "Compétences"
    },
    search: {
      placeholder: "Rechercher des histoires par titre...",
      characters: "Rechercher des personnages..."
    },
    filters: {
      title: "Filtres",
      reset: "Réinitialiser",
      apply: "Appliquer",
      sortBy: "Trier par",
      filterByRole: "Filtrer par rôle",
      name: "Nom",
      role: "Rôle",
      dateCreated: "Date de création",
      rating: "Évaluation",
      allRoles: "Tous les Rôles",
      roles: {
        all: "Tous les rôles",
        protagonist: "Personnage principal",
        antagonist: "Antagoniste",
        deuteragonist: "Personnage secondaire",
        mentor: "Mentor",
        comic_relief: "Comic Relief",
        mysterious: "Figure mystérieuse",
        love_interest: "Intérêt amoureux",
        anti_hero: "Anti-héros",
        sidekick: "Acolyte",
        shapeshifter: "Métamorphe",
        guardian: "Gardien",
        catalyst: "Catalyseur",
        character: "Personnage",
        supporting: "Personnage de soutien"
      }
    },
    deleteStory: {
      confirmTitle: "Supprimer l'Histoire",
      confirmMessage: "Êtes-vous sûr de vouloir supprimer cette histoire ? Cette action ne peut pas être annulée.",
      success: "Histoire Supprimée",
      successMessage: "L'histoire a été supprimée avec succès.",
      error: "Erreur",
      errorMessage: "Échec de la suppression de l'histoire. Veuillez réessayer."
    },
    navigation: {
      stories: "Histoires",
      characters: "Personnages",
      publicStories: "Histoires Publiques",
      stats: "Statistiques",
      more: "Plus"
    },
    loadingCharacters: "Chargement des personnages...",
    noCharactersFound: "Aucun personnage trouvé",
    createCharacter: {
      new: "Nouveau Personnage",
      title: "Créer un Nouveau Personnage",
      editTitle: "Modifier le Personnage",
      basicDetails: "Détails de Base",
      characteristics: "Caractéristiques",
      avatarDetails: "Détails de l'Avatar",
      personalityTraits: "Traits de Personnalité",
      form: {
        name: "Nom",
        namePlaceholder: "Entrez le nom du personnage",
        description: "Description",
        descriptionPlaceholder: "Entrez la description du personnage",
        role: "Rôle",
        selectRole: "Sélectionnez le rôle du personnage",
        personality: "Personnalité",
        personalityTraits: "Traits de personnalité",
        personalityPlaceholder: "Entrez les traits de personnalité",
        strengths: "Forces",
        strengthsPlaceholder: "Entrez les forces du personnage",
        weaknesses: "Faiblesses",
        weaknessesPlaceholder: "Entrez les faiblesses du personnage",
        skills: "Compétences",
        skillsPlaceholder: "Entrez les compétences du personnage",
        addTrait: "Ajouter un Trait",
        addStrength: "Ajouter une Force",
        addWeakness: "Ajouter une Faiblesse",
        addSkill: "Ajouter une Compétence",
        "add.Personality.Traits": "Ajouter des Traits de Personnalité",
        "add.Strengths": "Ajouter des Forces",
        "add.Weaknesses": "Ajouter des Faiblesses",
        "add.Skills": "Ajouter des Compétences",
        unnamedCharacter: "Personnage Sans Nom",
        cancel: "Annuler",
        create: "Créer le Personnage",
        update: "Mettre à Jour le Personnage"
      },
      buttons: {
        create: "Créer le Personnage",
        update: "Mettre à Jour le Personnage",
        cancel: "Annuler",
        updating: "Mise à jour en cours...",
        creating: "Génération en cours...",
      },
      avatarGenerator: {
        genderLabel: "Type d'Apparence",
        genderPlaceholder: "Sélectionner le type d'apparence",
        ageLabel: "Groupe d'Âge",
        agePlaceholder: "Sélectionner le groupe d'âge",
        hairLabel: "Description des Cheveux",
        hairPlaceholder: "ex., Longs cheveux noirs bouclés",
        eyeLabel: "Couleur des Yeux",
        eyePlaceholder: "ex., Bleu profond",
        clothingLabel: "Style Vestimentaire",
        clothingPlaceholder: "ex., Armure médiévale",
        expressionLabel: "Expression Faciale",
        expressionPlaceholder: "ex., Sourire confiant",
        generateButton: "Générer l'Avatar",
        generating: "Génération en cours...",
        previewLabel: "Avatar Généré",
        selectTitle: "Sélectionner l'Avatar",
        selectDescription: "Choisissez l'un des avatars générés pour votre personnage.",
        partialSuccess: "Certains avatars n'ont pas pu être générés",
        someImagesFailed: "Certains avatars n'ont pas pu être générés. Veuillez réessayer.",
        selectPreferred: "Sélectionnez votre avatar préféré",
        genderOptions: {
          male: "Humain - Masculin",
          female: "Humain - Féminin",
          // New animal options
          cat: "Animal - Chat",
          dog: "Animal - Chien",
          wolf: "Animal - Loup",
          fox: "Animal - Renard",
          rabbit: "Animal - Lapin",
          bird: "Animal - Oiseau",
          reptile: "Animal - Reptile",
          // Existing fantasy options
          elf: "Fantaisie - Elfe",
          dwarf: "Fantaisie - Nain",
          orc: "Fantaisie - Orc",
          vampire: "Fantaisie - Vampire",
          werewolf: "Fantaisie - Loup-garou",
          fairy: "Fantaisie - Fée",
          angelic: "Fantaisie - Être Angélique",
          demonic: "Fantaisie - Être Démoniaque",
          dragonborn: "Fantaisie - Né-dragon",
          centaur: "Fantaisie - Centaure",
          mermaid: "Fantaisie - Sirène/Triton",
          humanoid_alien: "Sci-Fi - Extraterrestre Humanoïde",
          insectoid_alien: "Sci-Fi - Extraterrestre Insectoïde",
          reptilian_alien: "Sci-Fi - Extraterrestre Reptilien",
          cyborg: "Sci-Fi - Robot/Cyborg",
          energy_being: "Sci-Fi - Être d'Énergie",
          tentacled: "Sci-Fi - Créature à Tentacules",
          cat_person: "Animal - Personne Chat",
          dog_person: "Animal - Personne Chien",
          wolf_person: "Animal - Personne Loup",
          fox_person: "Animal - Personne Renard",
          rabbit_person: "Animal - Personne Lapin",
          bird_person: "Animal - Personne Oiseau",
          reptile_person: "Animal - Personne Reptile",
          treant: "Mythique - Arbre Marchant",
          flower: "Mythique - Fleur Consciente",
          vine: "Mythique - Vigne Vivante",
          mushroom: "Mythique - Champignon Parlant",
          vegetable: "Mythique - Plante Animée",
          golem: "Mythique - Golem",
          ghost: "Mythique - Fantôme/Esprit",
          shapeshifter: "Mythique - Métamorphe"
        },
        ageOptions: {
          child: "Enfant",
          teen: "Adolescent",
          adult: "Adulte",
          elderly: "Âgé"
        },
        success: {
          title: "Avatar Généré",
          description: "L'avatar de votre personnage a été créé avec succès."
        },
        error: {
          title: "Échec de la Génération",
          description: "La génération de l'avatar a échoué. Veuillez réessayer."
        },
        upload: {
          button: "Télécharger un Avatar",
          uploading: "Téléchargement en cours...",
          success: {
            title: "Avatar téléchargé",
            description: "Votre avatar a été téléchargé avec succès"
          },
          error: {
            title: "Échec du téléchargement",
            fileTooLarge: "L'image de l'avatar doit être inférieure à 5 Mo",
            invalidType: "Veuillez télécharger un fichier image",
            failed: "Échec du téléchargement de l'image de l'avatar"
          },
          loading: "Chargement de l'image..."
        }
      },
      messages: {
        successCreated: {
          title: "Personnage Créé",
          description: "Votre personnage a été créé avec succès.",
        },
        successUpdated: {
          title: "Personnage Mis à Jour",
          description: "Votre personnage a été mis à jour avec succès.",
        },
        errorLoad: {
          title: "Erreur",
          description: "Échec du chargement du personnage. Veuillez réessayer.",
        },
        errorSave: {
          title: "Erreur",
          description: "Échec de la sauvegarde du personnage. Veuillez réessayer.",
        },
        validation: {
          characterName: {
            title: "Erreur",
            description: "Le nom du personnage est obligatoire.",
          },
        },
      },
    },
    characterTabs: {
      myCharacters: "Mes Personnages",
      publicCharacters: "Personnages Publics"
    },
    characterManagement: {
      delete: {
        title: "Supprimer le Personnage",
        confirmMessage: "Êtes-vous sûr de vouloir supprimer ce personnage ? Cette action ne peut pas être annulée.",
        cancel: "Annuler",
        delete: "Supprimer",
        deleting: "Suppression en cours...",
        success: {
          title: "Personnage supprimé",
          description: "Le personnage a été supprimé avec succès"
        },
        error: {
          title: "Erreur",
          description: "Échec de la suppression du personnage"
        }
      },
      visibility: {
        setPrivate: "Personnage défini comme privé",
        setPublic: "Personnage défini comme public",
        nowPrivate: "Le personnage est maintenant privé",
        nowPublic: "Le personnage est maintenant visible par tous",
        error: "Erreur",
        updateFailed: "Échec de la mise à jour de la visibilité du personnage"
      },
      rating: {
        submitted: "Évaluation soumise",
        thankYou: "Merci d'avoir évalué ce personnage !",
        error: "Erreur",
        failed: "Échec de la soumission de l'évaluation"
      }
    },
    suggestions: {
      personalities: {
        adaptable: "Adaptable",
        ambitious: "Ambitieux",
        brave: "Courageux",
        charismatic: "Charismatique",
        compassionate: "Compatissant",
        confident: "Confiant",
        creative: "Créatif",
        determined: "Déterminé",
        diplomatic: "Diplomatique",
        empathetic: "Empathique",
        honorable: "Honorable",
        humble: "Humble",
        humorous: "Humoristique",
        innovative: "Innovant",
        loyal: "Loyal",
        optimistic: "Optimiste",
        patient: "Patient",
        resilient: "Résilient",
        wise: "Sage",
        analytical: "Analytique",
        cautious: "Prudent",
        eccentric: "Excentrique",
        mysterious: "Mystérieux",
        pragmatic: "Pragmatique",
        reserved: "Réservé",
        stoic: "Stoïque",
        arrogant: "Arrogant",
        cynical: "Cynique",
        greedy: "Avide",
        hot_tempered: "Colérique",
        impulsive: "Impulsif",
        manipulative: "Manipulateur",
        obsessive: "Obsessionnel",
        paranoid: "Paranoïaque",
        prideful: "Orgueilleux",
        reckless: "Imprudent",
        ruthless: "Impitoyable",
        vengeful: "Vengeur"
      },
      skills: {
        leadership: "Leadership",
        negotiation: "Négociation",
        perception: "Perception",
        persuasion: "Persuasion",
        investigation: "Investigation",
        survival: "Survie",
        deception: "Tromperie",
        intimidation: "Intimidation",
        performance: "Performance",
        medicine: "Médecine",
        sword_fighting: "Escrime",
        archery: "Tir à l'arc",
        martial_arts: "Arts martiaux",
        stealth: "Furtivité",
        acrobatics: "Acrobatie",
        marksmanship: "Précision de tir",
        hand_to_hand: "Combat au corps à corps",
        tactical: "Tactique",
        magic: "Magie",
        elemental_control: "Contrôle des éléments",
        healing: "Guérison",
        necromancy: "Nécromancie",
        prophecy: "Prophétie",
        shapeshifting: "Métamorphose",
        telepathy: "Télépathie",
        telekinesis: "Télékinésie",
        alchemy: "Alchimie",
        summoning: "Invocation",
        hacking: "Piratage informatique",
        piloting: "Pilotage",
        robotics: "Robotique",
        cybernetics: "Cybernétique",
        nanotech: "Nanotechnologie",
        quantum_physics: "Physique quantique",
        ai_programming: "Programmation d'IA",
        bioengineering: "Bio-ingénierie",
        time_manipulation: "Manipulation temporelle",
        energy_weapons: "Armes à énergie",
        crafting: "Artisanat",
        cooking: "Cuisine",
        music: "Musique",
        art: "Art",
        writing: "Écriture",
        forgery: "Contrefaçon",
        invention: "Invention",
        linguistics: "Linguistique",
        history: "Histoire",
        science: "Science",
        psychology: "Psychologie",
        archaeology: "Archéologie",
        cryptography: "Cryptographie",
        strategy: "Stratégie",
        mythology: "Mythologie",
        economics: "Économie"
      }
    },
    upgradeForMore: "Mise à niveau pour plus",
    storiesRemaining: "Histoires restantes",
    storiesAvailable: "Histoires disponibles",
    by: "par",
    anonymous: "Anonyme",
    completed: "Terminée",
    public: "Publique",
    makePublic: "Rendre publique",
    makePrivate: "Rendre privée",
    upgradeToMakePublic: "Mettez à niveau pour rendre les histoires publiques",
    error: "Erreur",
    rating: {
      submitted: "Évaluation soumise",
      thankYou: "Merci d'avoir évalué cette histoire !",
      failed: "Échec de la soumission de l'évaluation"
    },
    upgrade: {
      required: "Mise à Niveau Requise",
      description: "Mettez à niveau votre compte pour rendre les histoires publiques et les partager avec d'autres.",
      shareStories: "Partagez vos histoires avec un abonnement premium",
      now: "Mettre à Niveau Maintenant"
    },
    startedTime: "Commencée {{time}}",
    storyVisibility: {
      madePublic: "L'histoire est devenue publique",
      madePrivate: "L'histoire est devenue privée",
      publicDescription: "Les autres peuvent désormais voir cette histoire",
      privateDescription: "Cette histoire est maintenant privée"
    },
    stats: {
      tabs: {
        badges: "Badges",
        stories: "Histoires",
        characters: "Personnages",
        engagement: "Engagement"
      },
      badges: {
        loading: "Chargement des badges...",
        earned: "Obtenu :",
        error: {
          title: "Erreur",
          loadBadges: "Échec du chargement des badges",
          loadProgress: "Échec du chargement de la progression des badges"
        },
        items: {
          "06491397-1302-45c5-85f7-31e5c46ed3d9": {
            name: "Écrivain Prolifique",
            description: "Terminer 100 histoires",
            category: "Écriture"
          },
          "0b4b084c-4344-4ad0-9b0c-99b03e6fccc8": {
            name: "Romancier Historique",
            description: "Terminer 3 histoires de fiction historique",
            category: "Genres"
          },
          "1a86f197-46e4-4158-bc93-461d83d52b5e": {
            name: "Écrivain d'Endurance",
            description: "Écrire des réponses pendant 30+ jours consécutifs",
            category: "Écriture"
          },
          "21a94bad-5405-4d27-ab85-2d4049d708aa": {
            name: "Résolveur de Mystères",
            description: "Terminer 10 histoires de mystère",
            category: "Genres"
          },
          "22e8ee37-d737-41ee-be9b-c3aa2e6d6898": {
            name: "Architecte de Dialogues",
            description: "Contribuer à 10 000 mots de dialogue à travers des interactions",
            category: "Écriture"
          },
          "258f5de2-f824-4bf1-adaf-e06df8cb27d0": {
            name: "Critique Supérieur",
            description: "Évaluer 20 personnages",
            category: "Communauté"
          },
          "2fb0b566-d564-4b54-8f74-b39130099161": {
            name: "Constructeur de Relations",
            description: "Créer des relations entre 5 personnages",
            category: "Personnages"
          },
          "59fd8282-02b7-49d9-912b-3137e5b72cf2": {
            name: "Sensation Virale",
            description: "Une histoire obtient 1 000+ vues",
            category: "Social"
          },
          "5a867724-a8ab-4ddd-a85c-b5864a5f8387": {
            name: "Penseur Profond",
            description: "Ajouter une histoire détaillée à 3 personnages",
            category: "Personnages"
          },
          "66cc4e5d-2a9e-48d7-ae08-4d51993b4693": {
            name: "Papillon Social",
            description: "Évaluer 20 histoires",
            category: "Communauté"
          },
          "741e00ae-a32d-4495-9191-bd52d90389d2": {
            name: "Amateur d'Horreur",
            description: "Terminer 20 histoires d'horreur",
            category: "Genres"
          },
          "8a28897b-8993-4b11-a9c6-490703d87066": {
            name: "Démarreur de Séries",
            description: "Publier la première histoire d'une série en plusieurs parties",
            category: "Écriture"
          },
          "98ed9a67-4eb9-4c2c-b119-ab270373346a": {
            name: "Voix Équilibrée",
            description: "Obtenir plus de réponses éditées par l'utilisateur",
            category: "Écriture"
          },
          "99820441-a9eb-4c9e-a044-80dcf23c0dd6": {
            name: "Maître du Parrainage",
            description: "Invite et fais adhérer 10 amis",
            category: "Social"
          },
          "b19a40af-d02c-4e68-9cf2-29ed0609132b": {
            name: "Encourageur",
            description: "Donner 20+ réactions positives aux histoires",
            category: "Communauté"
          },
          "bb25222d-2bf7-4c3d-9c69-3ee6fdc8f74c": {
            name: "Maître des Instructions",
            description: "Fournir 100 instructions uniques d'utilisateur",
            category: "Écriture"
          },
          "d6178364-f775-483b-ac86-ebcab6f469df": {
            name: "Promoteur",
            description: "Partager 5 histoires sur les réseaux sociaux",
            category: "Social"
          },
          "d9d3b0ad-5512-4f57-afc4-02795f488cea": {
            name: "Chuchoteur d'IA",
            description: "Accepter des réponses générées par IA 500 fois",
            category: "Écriture"
          },
          "dcbda3da-f44f-468e-b650-0ba2b49de57b": {
            name: "Artiste de Personnages",
            description: "Générer un avatar pour un personnage",
            category: "Personnages"
          },
          "f2f6cb19-eff1-40cb-90e7-d69a13b1cee6": {
            name: "Écrivain Quotidien",
            description: "Créer une histoire pendant 7 jours consécutifs",
            category: "Écriture"
          },
          "f793ac53-913f-4b17-a534-08d34a768544": {
            name: "Distribution Dynamique",
            description: "Utiliser 20+ personnages différents dans les histoires",
            category: "Personnages"
          },
          "f949c0fc-ffab-4c4b-8cb9-050af34bfd66": {
            name: "Expérimentateur",
            description: "Terminer dans 10+ genres différents dans les histoires",
            category: "Genres"
          }
        }
      },
      storyStats: {
        loading: "Chargement des statistiques...",
        totalStories: "Total des Histoires",
        completed: "Terminées",
        published: "Publiées",
        averageRating: "Évaluation Moyenne",
        categoryRelationships: "Relations entre Catégories",
        primaryCategory: "Catégorie Principale",
        secondaryCategory: "Catégorie Secondaire",
        selectCategory: "Sélectionner une catégorie",
        genre: "Genre",
        themes: "Thèmes",
        environment: "Environnement",
        noCategoryData: "Aucune donnée de catégorie disponible",
        lessFrequent: "Moins fréquent",
        moreFrequent: "Plus fréquent",
        usageDescription: "Montre la fréquence à laquelle les catégories sont utilisées ensemble dans vos histoires",
        stories: "histoires",
        noDataAvailable: "Aucune donnée disponible",
      },
      characterStats: {
        loading: "Chargement des statistiques des personnages...",
        totalCharacters: "Total des Personnages",
        publicCharacters: "Personnages Publics",
        averageRating: "Évaluation Moyenne",
        traitRelationships: "Relations entre les Traits de Personnage",
        primaryTraitType: "Type de Trait Principal",
        secondaryTraitType: "Type de Trait Secondaire",
        selectTraitType: "Sélectionner un type de trait",
        personalityTraits: "Traits de Personnalité",
        strengths: "Forces",
        weaknesses: "Faiblesses",
        skills: "Compétences",
        noTraitData: "Aucune donnée de relation de traits disponible",
        lessFrequent: "Moins fréquent",
        moreFrequent: "Plus fréquent",
        usageDescription: "Montre la fréquence à laquelle différents traits apparaissent ensemble dans vos personnages",
        characters: "personnages"
      },
      engagementStats: {
        loading: "Chargement des statistiques...",
        totalStories: "Total des Histoires",
        avgCustomization: "Personnalisation Moyenne",
        avgWordCount: "Nombre Moyen de Mots",
        currentStreak: "Série Actuelle",
        days: "jours",
        monthlyProgress: "Progression Mensuelle"
      }
    },
    author: {
      title: 'Profil d\'Auteur',
      credits: 'Crédits d\'Histoire',
      creditsAvailable: 'Vous avez {{count}} crédits disponibles',
      memberSince: 'Membre TaleCraft',
      loading: 'Chargement...',
      recentBadges: 'Badges Récents',
      noBadgesYet: 'Pas encore de badges gagnés',
      earnedOn: 'Gagné le {{date}}',
      more: 'plus'
    },
    access: {
      restricted: "Accès Restreint",
      loginRequired: "Connexion Requise",
    }
  }
};
